import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {UiConfirmationDialogService, UiToastMessageService, UiTranslateLoaderService} from 'ui-shared';
import {FormGroup, Validators} from "@angular/forms";
import {finalize, Observable} from "rxjs";
import {FileOwnershipModel} from "../../../module/file-upload/file-ownership-model";

@Component({
    selector: 'image-uploader',
    templateUrl: './image-uploader.component.html',
    styleUrls: ['./image-uploader.scss'],
})
export class ImageUploaderComponent implements OnInit {
    @ViewChild('fileUploader', {static: true}) fileUpload;
    @Input() form: FormGroup;
    @Input() formControlName: string;
    @Input() showRemove: boolean=true;

    private _pictureSrc: any;
    @Input() set pictureSrc(val: any) {
        if (val === this._pictureSrc) return;
        this._pictureSrc = val;
    }

    get pictureSrc(): any {
        return this._pictureSrc;
    }
    @Input() disabled: boolean;
    @Input() maxSizeInMb: number = 2;
    @Input() heightPx: number = 160;
    @Input() widthPx: number = 120;
    @Input() label: string;
    @Input({ required: true }) uploadCallback: (file: File) => Observable<FileOwnershipModel>;
    @Input() removeCallback: () => Observable<any>;

    constructor(
        private uiToastMessageService: UiToastMessageService,
        private uiTranslateService: UiTranslateLoaderService,
        private confirmationDialogService: UiConfirmationDialogService,
    ) {}
    ngOnInit() {
    }

    public onFileSelected($event) {
        let file: File = $event.files[0];
        if (file.size > this.maxSizeInMb * 1000000) {
            this.uiToastMessageService.showError(
                this.uiTranslateService.instant('hrCommon.fileSizeErrPicture', this.maxSizeInMb),
            );
            this.form?.get(this.formControlName).setValue(null);
            this.fileUpload.clear();
            return;
        }
        this.uploadCallback(file)
            .pipe(
                finalize(() => {
                    this.fileUpload.clear();
                }),
            )
            .subscribe((ownership) => {
                this.pictureSrc = URL.createObjectURL(file);
                this.form.get(this.formControlName).setValue(ownership);
            });
    }

    get isRequired() {
        return this.form?.get(this.formControlName)?.hasValidator(Validators.required);
    }

    removePicture() {
        this.confirmationDialogService.showDeleteConfirmDialog(() => {
            if (this.removeCallback) this.removeCallback().subscribe(() => this.clearPicture());
            else this.clearPicture();
        }, this.imageUploaderConfirmDialogKey);
    }

    private clearPicture() {
        URL.revokeObjectURL(this.pictureSrc);
        this.pictureSrc = null;
        this.form?.get(this.formControlName)?.setValue(null);
        this.fileUpload.clear();
    }

    get imageUploaderConfirmDialogKey() {
        return 'imageUploaderConfirmDialogKey';
    }
}
